export enum InstitutionSettingsEnum {
	APPOINTMENT = 'appointmentSettings',
	TEXT_TEMPLATE = 'textTemplates',
	GDPR = 'gdpr'
}
